import { RouteConfig } from 'vue-router';

import ConsultaParecerReferencial from '../ConsultaParecerReferencial.vue';
import RelatorioParecerReferencial from '../RelatorioParecerReferencial.vue';
import CadastroParecerReferencial from '../CadastroParecerReferencial.vue';

const baseRouterLink = '/privado/parecer-referencial';

const ParecerReferencialRoutes: RouteConfig[] = [
  {
    path: `${baseRouterLink}/relatorio/vencidos`,
    name: 'vencidos-proximos-vencimento',
    component: RelatorioParecerReferencial,
  },
  {
    path: `${baseRouterLink}/consulta`,
    name: 'parecer-referencial',
    component: ConsultaParecerReferencial,
  },
  {
    path: `${baseRouterLink}/cadastro/:cdParecerReferencial?`,
    name: 'cadastro',
    component: CadastroParecerReferencial,
  },
];

export default ParecerReferencialRoutes;
